<template>
  <div class="map-content-wrap">
    <!-- <div>
      <h2>Search and add a pin</h2>
      <label>
        <gmap-autocomplete @place_changed="setPlace"></gmap-autocomplete>
        <button @click="addMarker">Add</button>
      </label>
      <br />
    </div>
    <br />-->
    <gmap-map
      :center="center"
      @click="handleClick"
      @rightclick="handleClick"
      :zoom="zoom"
      style="width:100%;  height: 420px;"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :draggable="true"
        @drag="updateCoordinates"
        @click="center=m.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
  name: "GoogleMap",
  data() {
    return {
      center: { lat: 27.70169, lng: 85.3206 },
      markers: [],
      places: [],
      zoom: 16,
      coordinates: null,
      currentPlace: null
    };
  },

  mounted() {
    this.geolocate();
  },

  methods: {
    ...mapActions(["markerChange"]),
    updateCoordinates(location) {
      this.coordinates = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
    },
    handleClick(e) {
      const marker = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      };
      this.markers = [
        {
          position: marker
        }
      ];
      this.markerChange(this.markers);
    },
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },
    geolocate: function() {
      if (location.protocol != "https:") {
        this.zoom = 12;
      } else {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.markers.push({
            position: {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          });
          this.markerChange(this.markers);
        });
      }
    }
  }
};
</script>

<style lang="scss">
.map-content-wrap {
  margin-bottom: 30px;
  .gmnoprint {
    display: none !important;
  }
}

@media only screen and (max-width: 767px) {
  .map-content-wrap {
    margin: 50px 0 30px;
  }
}
</style>